import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {InputsBindingsModel} from '../../../../../common/Models/Dialog/inputs-binding.model';
import {DialogRef} from '../../../../../common/Forms/Dialog-types/dialog-ref';
import {NotificationDialogComponent} from '../../../../../common/Forms/Dialogs/notification-dialog/notification-dialog.component';
import {ButtonInfo} from '../../../../../common/UI-Components/helperClasses/value-and-display.class';
import {DialogModel} from '../../../../../common/Models/Dialog/dialog.model';
import {DialogService} from '../../../../../services/dialogs.service';
import {SessionApiSvc} from '../../../../../services/api.services/session.api.svc';
import {CMD_ACTIONS, CMD_TARGETS, CmdRouterService} from '../../../../../services/cmd-router.service';
import {Store} from '@ngxs/store';
import {IUserData} from 'src/app/services/user-details.service';
import {LoginThrough, ICompanyInfo, ISessionMetaData} from 'src/app/common/Models/UI/company-info.interface';
import { TooltipDirective } from '../../../../../Directives/tooltip.directive';
import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AppDiscoveryService } from 'src/app/services/app-discovery.service';

@Component({
    selector: 'ins-profile-panel',
    templateUrl: './profile-panel.component.html',
    styleUrls: ['./profile-panel.component.scss', './../submenus-shared-design.scss',
        './../../../../../common/UI-Components/shared-UI-components.scss'],
    imports: [TooltipDirective, PerfectScrollbarModule, MatIcon, RouterModule]
})
export class ProfilePanelComponent implements OnChanges {

  @Input() user: IUserData = null;
  public userTitle = "Temp User";

  @Output()
  public closePanel: EventEmitter<void> = new EventEmitter();

  public showSignOut = true;
  public closeViewBtnTxt = "";
  private loginThrough: LoginThrough = LoginThrough.Main;
  private currentPage: string = '';
  constructor(public dialogService: DialogService, private readonly sessionApiSvc: SessionApiSvc, private readonly  cmdRouterSvc: CmdRouterService, 
    private readonly store: Store, private readonly router: Router, private readonly appDiscoveryService: AppDiscoveryService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.split('?')[0];
        const segments = url.split('/').filter(Boolean);
        this.currentPage = segments.length > 0 ? `${segments[0]}` : '';

        if (this.currentPage === 'usermanagement') {
          this.showSignOut = false;
          this.closeViewBtnTxt = "User Management";
        } else if (this.currentPage === 'rolemanagement') {
          this.showSignOut = false;
          this.closeViewBtnTxt = "Role Management";
        } else if (this.currentPage === 'Tour') {
          const sessionMetaData: ISessionMetaData = this.sessionApiSvc.getSessionMetaData();
          this.loginThrough = sessionMetaData.loginThrough;
          if (this.loginThrough != LoginThrough.Tour && this.appDiscoveryService.hasOtherTabsOpen()) {
            this.showSignOut = false;
            this.closeViewBtnTxt = "Tour";
          }
        }
      }
    });
  }

  ngOnChanges() {
    if(this.user){
      const companyInfo = this.store.selectSnapshot<ICompanyInfo>((state: any) => state.StateApp.companyInfo );
      if (companyInfo.ssoEnable) {
        this.userTitle = this.user.email;
      } else {
        this.userTitle = this.user.name + ' ' + this.user.family;
      }
    }
  }

  closeApplicationTab(): void {
    this.router.navigate(['/appLanding'], { 
      queryParams: { previousRoute: this.currentPage } 
    });
  }

  signOut(): void {
    const inputsBinding: InputsBindingsModel = new Map([
      [ 'type', 'warning'],
      [ 'title', 'Sign-Out' ],
      [ 'message', 'Are you sure you want to sign-out?\n']
    ]);
    const dialog: DialogRef = this.dialogService.createNotificationDialog(inputsBinding);
    const dialogComp: NotificationDialogComponent = (dialog.instance as NotificationDialogComponent);

    dialogComp.buttonsInfo = [
      new ButtonInfo('no', 'No'),
      new ButtonInfo('yes', 'Yes'),
    ];
    dialog.onClose$().subscribe((model: DialogModel) => {
      if (model.userAction === 'yes') {
        if (this.currentPage == 'Tour') {
          this.tourSignout();
        } else {
          this.cmdRouterSvc.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.CLEAR_SCENE);
          this.cmdRouterSvc.sendActionCmd(CMD_TARGETS.WEBGL_MANAGER, CMD_ACTIONS.CLEAR_SCENE);
          this.sessionApiSvc.closeSession();
        }
      }
    });
  }

  tourSignout(): void {
    this.sessionApiSvc.closeSession();
    sessionStorage.removeItem('pid');
    sessionStorage.removeItem('auth_item');
  }

  public getToolTipConf(element: any, label: string): any {
    const toolTipConf = {text: '', position: { H: 'hRight', V:'vTop' }, type: 'info'};
    if ( element.offsetWidth < element.scrollWidth )  {
      toolTipConf.text = label;
    }
    return toolTipConf;
  }
}
